import React from "react";
import { Toast, ToastBody, ToastHeader } from "reactstrap";
import { ToastPlacementProp } from "../../../../types/BonusUi";
import { dynamicImage } from "../../../../utils";
import { Image } from "../../../../coreComponents/Image";

const ToastPlacementContent: React.FC<ToastPlacementProp> = ({ selectedPosition }) => {
  return (
    <div className="bg-light position-relative bd-example-toasts">
      <div className={`toast-container p-3 position-absolute ${selectedPosition}`} id="toastPlacement">
        <Toast fade>
          <ToastHeader className="toast-img">
            <Image className="rounded me-2" src={dynamicImage(`dashboard-8/profile.png`)} alt="profile" />
            {"Berlin Theme"}
            <small>{"25 min ago"}</small>
          </ToastHeader>
          <ToastBody className="toast-dark txt-dark">
            <p className="toast-content">
              <em className="txt-danger">{"Attackers"}</em>
              {" on malicious activity may trick you into doing something dangrous like installing software or revealing your personal informations."}
            </p>
          </ToastBody>
        </Toast>
      </div>
    </div>
  );
};
export default ToastPlacementContent;
